import { CodeTypeModel } from "./code-type.model";

export class CompanyModel {
    ID: string;
    Name: string;
    Logo: string;
    ModifyDate: Date;
    CompanyInfo: CompanyInfoModel;
    Warranty: TextEditorModel;
    ServiceAgreementTermsAndCondition: TextEditorModel;
    PrintContentPreferenceList: string[];
    EstimateTermsAndCondition: TextEditorModel;

    constructor() {
        this.ID = "";
        this.Name = "";
        this.Logo = "";
        this.CompanyInfo = new CompanyInfoModel();
        this.Warranty = new TextEditorModel();
        this.ServiceAgreementTermsAndCondition = new TextEditorModel();
        this.PrintContentPreferenceList = [];
        this.EstimateTermsAndCondition = new TextEditorModel();
    }
}

export class CompanyInfoModel {
    ID: string;
    StreetAddress: string;
    Unit: string;
    City: string;
    State: string;
    ZipCode: string;
    PhoneNumber: number;
    FaxNumber: number;
    MobileNumber: number;
    EmailAddress: string;
    LicenseNumber: string;
    Comment: string;
    SiteURL: string;
    InvoiceFooter: string;
    ServiceAgreementFooter: string;
    AccountingIntegrationType: CodeTypeModel;
    EstimateFooter: string;

    constructor() {
        this.ID = "";
        this.StreetAddress = "";
        this.Unit = "";
        this.City = "";
        this.State = "";
        this.EmailAddress = "";
        this.Comment = "";
        this.InvoiceFooter = "";
        this.LicenseNumber = "";
        this.SiteURL = "";
        this.ServiceAgreementFooter = "";
        this.AccountingIntegrationType = new CodeTypeModel();
        this.EstimateFooter = "";
    }
}

export class TextEditorModel {
    ID: string;
    Content: string;
        
    public SetContent(val: string) {
        this.Content = new XMLSerializer().serializeToString(new DOMParser().parseFromString(val, 'text/html')).replace('<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>', '').replace('</body></html>', '');
    }
    
    constructor() {
        this.ID = "";
        this.Content = "";
    }
}